import axios from "axios";

const postAppointmentPayment = async (baseUrl, token, patientId, barcode) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.post(baseUrl + `/patient/` + patientId + "/appointment/" + barcode + "/payment", {}, config)
        .then((res) => {
            putResponse = {
                status: res.data.status,
                result: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    result: error.response.status
                }
            }
        });
    return putResponse
}

export default postAppointmentPayment;